import FondoConfirmar from "./FondoConfirmar";

export default function FondosConfirmar({ fondos }) {
    return fondos.map((f, i) => <FondoConfirmar key={i} fondo={f} />);
};